// @flow

import type { Tracker } from './combine'

import combineTrackers from './combine'
import fengjr from './fengjr'
import ga from './ga'

type Vendor = 'fengjr' | 'ga' | 'ptengine';

let tracker: Tracker

function init (...vendors: Vendor[]) {
  if (tracker) {
    throw new Error('analysis can only init once')
  }

  const trackers = vendors.map(vendor => {
    switch (vendor) {
      case 'fengjr':
        return fengjr
      case 'ga':
        return ga()
      default:
        throw new Error('invalid analysis vendor')
    }
  })
  tracker = combineTrackers(trackers)
  tracker.init()
}

function trackPageview (page?: string, prePage?: string) {
  if (tracker) {
    tracker.trackPageview(page, prePage)
  }
}

function trackEvent (name: string) {
  if (tracker) {
    tracker.trackEvent(name)
  }
}

function trackEventValue (name: string, value: string | {}) {
  if (tracker) {
    tracker.trackEventValue(name, value)
  }
}

function setUid (uid: string) {
  if (tracker) {
    tracker.setUid(uid)
  }
}

function setCustomVar (key: string, value: string) {
  if (tracker) {
    tracker.setCustomVar(key, value)
  }
}

export {
  init,
  trackPageview,
  trackEvent,
  trackEventValue,
  setUid,
  setCustomVar
}



// WEBPACK FOOTER //
// ./src/frame/core/analysis/index.js